import { render, staticRenderFns } from "./chooseRole.vue?vue&type=template&id=75f4e798&"
import script from "./chooseRole.vue?vue&type=script&lang=js&"
export * from "./chooseRole.vue?vue&type=script&lang=js&"
import style0 from "./chooseRole.vue?vue&type=style&index=0&id=75f4e798&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports